class ScaleHandler {
    constructor() {
    }

    fromSliderScale(ticks, value) {
        const floor = Math.floor(value);

        if (floor === value) {
            return ticks[floor]
        }

        let actualValue =  ticks[floor] + ((value - floor) *  (ticks[floor + 1] - ticks[floor]));
        let granularity = ticks[floor + 1] / 50;

        return Math.ceil(actualValue / granularity) * granularity;
    };

    toSliderScale(ticks, value) {
        if (value >= ticks[ticks.length - 1]) {
            return ticks.length - 1;
        }

        let ceilIndex;
        for (var i = 0; i < ticks.length; i++) {
            let tick = ticks[i];
            if (tick >= value) {
                ceilIndex = i;
                break;
            }
        }

        if (ticks[ceilIndex] == value) {
            return ceilIndex;
        }

        return ceilIndex - 1 + ((value - ticks[ceilIndex - 1]) / (ticks[ceilIndex] - ticks[ceilIndex - 1]))
    }
}

export default ScaleHandler;